export default {
  bot: 'Bot',
  name: 'Fila',
  waitingTickets: 'Tickets en espera',
  openedTickets: 'Tickets en atención',
  averageResponseTime: 'Tiempo medio de respuesta',
  averageAttendanceTime: 'Tiempo de atención',
};
